import styled from 'styled-components'

export const Matrix = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const StyledImage = styled.img`
  width: 35%;
  @media (max-width: ${(props) => props.theme.responsive.laptopM}) {
    display: none;
  }
`
export const UpperDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4rem;
  @media (max-width: ${(props) => props.theme.responsive.laptopM}) {
    flex-direction: column;
  }
`
export const FormDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 65%;
  @media (max-width: ${(props) => props.theme.responsive.laptopM}) {
    width: 100%;
  }
`
export const Container = styled.div`
  display: flex;
  gap: 2rem;
  padding: 3rem 5rem;
  box-shadow: ${(props) => props.theme.boxShadow.shadow1};
  border-radius: 20px;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  @media (max-width: ${(props) => props.theme.responsive.laptopM}) {
    width: 90%;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
  }
  @media (max-width: ${(props) => props.theme.responsive.tablet}) {
    width: 90%;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
  }
`
export const StyledButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  gap: 2rem;
  @media (max-width: ${(props) => props.theme.responsive.laptopM}) {
    width: 50%;
  }
  @media (max-width: ${(props) => props.theme.responsive.mobileL}) {
    width: 100%;
  }
`
export const Info = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 100%;
  flex-wrap: wrap;
  @media (max-width: ${(props) => props.theme.responsive.mobileL}) {
    margin-top: 1rem;
    gap: 0.75rem;
    justify-content: flex-end;
  }
`
export const SingleInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
